/* eslint-disable react/react-in-jsx-scope */
// REMOVE HERE BEFORE DEPLOY
import { Button } from '@components/atoms'
import { LoaderContainer } from '@components/organisms/Modal/ReportModal/ReportModal.style'
import { useAuthObserver } from '@core/hooks'
import { Fragment, useCallback, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import {
  Checkbox,
  Form,
  FormControl,
  FormGroup,
  Loader,
  SelectPicker
} from 'rsuite'
import { LineHorizontal } from '../Report/Report.style'
import {
  CommentListLayout,
  FormControlCheckbox,
  FormControlHelperText,
  FormControlLabel,
  FormGroupFlex,
  ImagePreviewFormWrapper
} from './ImagePreviewForm.style'
import TrashIcon from './TrashIcon/TrashIcon'

const judgementOption = ['OK', 'NG'].map((item) => ({
  label: item,
  value: item
}))

const ImagePreviewForm = ({
  commentList = [],
  handleCreateComment,
  handleRemove,
  renderFlag,
  designGroupOption,
  formValue,
  setFormValue,
  handleChangeJudgement,
  loadingComment,
  loadingFrom,
  handleChangeFeedbackCheckbox,
  technicalDesignFeedbackOption
}) => {
  const isMountedRef = useRef(true)
  const { t } = useTranslation()
  const { user, isTDEMRole, isAdminRole } = useAuthObserver()
  const userId = user?.userId

  useEffect(() => {
    return () => {
      isMountedRef.current = false
    }
  }, [])

  const safeHandleChangeFeedbackCheckbox = useCallback((item, value) => {
    if (!isMountedRef.current) return
    handleChangeFeedbackCheckbox(item, value)
  }, [])

  const formatDate = (isoDate) => {
    const date = new Date(isoDate)
    return `${t('page-search.photoModal.date')}: ${date.getDate()}/${
      date.getMonth() + 1
    }/${date.getFullYear()} ${t(
      'page-search.photoModal.time'
    )}: ${date.getHours()}:${date.getMinutes()}`
  }

  const feedbackMapping = {
    1: t('page-search.technicalDesignFeedback.qualitySubmission'),
    2: t('page-search.technicalDesignFeedback.gapUnderstanding'),
    3: t('page-search.technicalDesignFeedback.wrongLogicJudgment'),
    4: t('page-search.technicalDesignFeedback.others')
  }

  return (
    <ImagePreviewFormWrapper>
      <CommentListLayout
        style={{
          justifyContent: commentList.length === 0 ? 'center' : 'start'
        }}
      >
        {loadingComment ? (
          <LoaderContainer>
            <Loader />
          </LoaderContainer>
        ) : commentList.length > 0 ? (
          commentList.map((comment, index) => (
            <article
              key={comment.id}
              style={{
                display: 'flex',
                position: 'relative',
                flexDirection: 'column',
                gap: 16,
                padding: 20,
                border: '1px solid #dedede',
                backgroundColor: '#fff',
                borderRadius: 5
              }}
            >
              {(comment.ownerUserId === userId || isTDEMRole) && (
                <TrashIcon
                  onClick={(event) => handleRemove(event, comment.id)}
                  renderFlag={renderFlag}
                />
              )}
              <div
                style={{ display: 'flex', flexDirection: 'column', margin: 0 }}
              >
                <div>
                  <b className="title">
                    {t('page-search.photoModal.technicianDesignGroup')}:{' '}
                  </b>
                  <b className="technical-design-group">
                    {comment.group.toString()}
                  </b>
                </div>
                {comment.judgement && (
                  <div style={{ marginTop: '-10px' }}>
                    <b className="title">
                      {t('page-search.photoModal.judgement')}:{' '}
                    </b>
                    <b className="technical-design-group">
                      {comment.judgement.toString()}
                    </b>
                  </div>
                )}
              </div>
              <div>
                {Object.entries(feedbackMapping).map(
                  ([key, translationKey]) => {
                    const hasValue = comment.technicalDesignFeedbackList.some(
                      (feedback) => feedback.name === parseInt(key)
                    )

                    return hasValue ? (
                      <p key={key} className="comment" style={{ margin: 0 }}>
                        {translationKey}
                      </p>
                    ) : null
                  }
                )}
              </div>
              <p className="comment">{comment.comment}</p>
              <span className="create-at">
                {t('page-search.photoModal.createBy')} {comment.createdBy}
                <div>{formatDate(comment.createdAt)}</div>
              </span>
            </article>
          ))
        ) : (
          <div style={{ fontSize: '18px', textAlign: 'center' }}>
            {t('page-search.alert.comment.noComment')}
          </div>
        )}
      </CommentListLayout>
      <LineHorizontal />
      <Form
        fluid
        formDefaultValue={{
          ...formValue,
          comment: sessionStorage.getItem('comment')
        }}
        onSubmit={() => handleCreateComment()}
        style={{ width: '100%' }}
      >
        <FormGroupFlex>
          <FormGroup style={{ width: '100%' }}>
            <FormControlLabel>
              {t('page-search.photoModal.judgement')}
            </FormControlLabel>
            <FormControl
              onChange={handleChangeJudgement}
              name="judgement"
              accepter={SelectPicker}
              data={judgementOption}
              searchable={false}
              cleanable={false}
              disabled={loadingFrom || !isAdminRole}
              style={{ width: '100%' }}
            />
          </FormGroup>
        </FormGroupFlex>
        <FormGroupFlex>
          <FormGroup style={{ width: '100%' }}>
            <FormControlLabel>
              {t('page-search.photoModal.technicianDesignGroup')}
            </FormControlLabel>
            <FormControl
              onChange={(value) =>
                setFormValue((prev) => ({
                  ...prev,
                  designGroups: value
                }))
              }
              name="designGroups"
              accepter={SelectPicker}
              data={designGroupOption}
              searchable={false}
              cleanable={false}
              disabled={loadingFrom}
              style={{ width: '100%' }}
            />
          </FormGroup>
        </FormGroupFlex>
        <FormGroup style={{ marginBottom: '0px' }}>
          <FormControlLabel id="button-submit">
            {t('page-search.photoModal.technicianComment')}
          </FormControlLabel>
          {technicalDesignFeedbackOption?.map((item) => {
            return (
              <Fragment key={item.label}>
                <FormControlCheckbox
                  onChange={(_, value) => {
                    safeHandleChangeFeedbackCheckbox(item, value)
                  }}
                  name={item.label.replaceAll(' ', '_')}
                  checked={
                    formValue.technicalDesignFeedbackList?.some(
                      (feedback) => feedback.label === item?.label
                    ) ?? false
                  }
                  disabled={loadingFrom}
                  accepter={Checkbox}
                >
                  {item.label}
                  <FormControlHelperText>{item.desc}</FormControlHelperText>
                </FormControlCheckbox>
              </Fragment>
            )
          })}
        </FormGroup>
        <FormGroup style={{ marginBottom: '16px' }}>
          <FormControl
            rows={3}
            name="comment"
            onChange={(value) => {
              sessionStorage.setItem('comment', value)
            }}
            disabled={loadingFrom}
            componentClass="textarea"
          />
        </FormGroup>
        <FormGroup
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <Button
            style={{ width: 150, marginLeft: 'auto' }}
            type="submit"
            disabled={loadingFrom}
          >
            {t('page-search.photoModal.send')}
          </Button>
        </FormGroup>
      </Form>
    </ImagePreviewFormWrapper>
  )
}

export default ImagePreviewForm
